export function parsePolicyIdentifier({ identifier }: { identifier: string }) {
  const match = /^(.*):v?(\d+)$/.exec(identifier);
  return match && match[1]
    ? { name: match[1], version: Number(match[2]) }
    : { name: identifier, version: null };
}

export function isPolicyUuid({ value }: { value: string }) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value,
  );
}

export function formatPolicyDate(value: string) {
  return new Date(value).toLocaleString("en-US", {
    timeZone: "UTC",
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function titleizePolicyStatus(value: string) {
  return value
    .replaceAll("_", " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function formatPolicyScore(score: number) {
  const magnitude = Math.abs(score);

  if (magnitude >= 1_000_000_000)
    return `${(score / 1_000_000_000).toFixed(1)}B`;

  if (magnitude >= 1_000_000) return `${(score / 1_000_000).toFixed(1)}M`;

  if (magnitude >= 1_000) return `${(score / 1_000).toFixed(1)}K`;

  return score.toFixed(2);
}
